import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { Banner } from '../models/banner.model';

/** Cliente de los banners públicos activos (BP-02 / FP-27, spec §17). */
@Injectable({ providedIn: 'root' })
export class BannersPublicoService {
  private readonly http = inject(HttpClient);

  /**
   * GET /publico/banners — banner activo de la franja superior y de la
   * inferior. Las secciones sin banner cargado no vienen en la respuesta.
   */
  activos(): Observable<Banner[]> {
    return this.http.get<Banner[]>(`${environment.apiUrl}/publico/banners`);
  }
}
